// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"53c3000a","196":"2ab77dc3","376":"0e2e2206","583":"2bfe56b0"}[chunkId] + ".chunk.js";
};